import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _wrapNativeSuper from "@babel/runtime/helpers/esm/wrapNativeSuper";
import React from 'react';
import { isBrowser } from "../client"; // NOTE: Copy-paste from @types/react

export var delay = function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};
export var emptyHandler = function emptyHandler() {
  /* noop */
};
export var CancelationError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(CancelationError, _Error);

  function CancelationError() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Error.call.apply(_Error, [this].concat(args)) || this;
    _this.code = 'CancelationError';
    return _this;
  }

  return CancelationError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
export function taskWithDelay(task, ms) {
  var cancelationToken = function cancelationToken() {
    return null;
  };

  new Promise(function (resolve, reject) {
    cancelationToken = reject;
    setTimeout(resolve, ms);
  }).then(task)["catch"](function () {
    return null;
  });
  return cancelationToken;
}
export function isFunction(x) {
  return typeof x === 'function';
}
export function isFunctionalComponent(Component) {
  return typeof Component === 'function' && !(Component.prototype && Component.prototype.isReactComponent);
}
export function escapeRegExpSpecChars(s) {
  return s.replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
}
export var getRandomID = function getRandomID() {
  return Math.random().toString(16).slice(2);
};
export var isExternalLink = function isExternalLink(link) {
  return new RegExp("^(https?:)?//" + (isBrowser ? "(?!" + window.location.host + ")" : "") + "\\S+", 'gi').test(link);
};
/**
 * Check if the given ReactNode is an element of the specified ReactUI component
 */

export var isReactUINode = function isReactUINode(componentName, node) {
  if ( /*#__PURE__*/React.isValidElement(node)) {
    return Object.prototype.hasOwnProperty.call(node.type, '__KONTUR_REACT_UI__') && // @ts-ignore
    node.type.__KONTUR_REACT_UI__ === componentName;
  }

  return false;
};
/**
 * Проверяет, не является ли переданный аргумент null или undefined и исключает типы null и undefined из типа аргумента
 *
 * @param value Значение, которое нужно проверить и исключить из него типы
 * @returns Возвращает true, если переданный аргумент не является null или undefined иначе false
 */

export var isNonNullable = function isNonNullable(value) {
  return value !== null && value !== undefined;
};